export default __webpack_public_path__ + "static/media/docFileIcon.cc4f0fcd.svg";